<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <currency-field label="本位币" v-model="value" />
      </div>
      <div class="weui-cells__title">
        本位币修改后，将修改以下数据：
        <ol class="text-list">
          <li>采购单、销售订单汇率；</li>
          <li>客户应收本币余额、供应商应付本币余额；</li>
          <li>采购入库、采购退货、销售出货、销售退货汇率；</li>
          <li>其它入库、其它出库、盘盈入库、盘亏出库、库存导入币种；</li>
          <li>重算采购入库、其它入库、盘盈入库成本；</li>
          <li>请自行确认修改库存初始化及销售退货成本；</li>
          <li>科目核算单一外币且外币为新本位币的，将更新为不核算外币，并取消期末调汇</li>
        </ol>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import CurrencyField from "@/components/field/CurrencyField.vue";

export default {
  components: {
    CurrencyField
  },
  data() {
    return {
      baseUrl: "/api/commons/configs",
      value: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.loadData();
    });
  },
  methods: {
    loadData() {
      var me = this;
      me.$loading({
        url: me.baseUrl + "/getConfigByCode",
        params: {
          code: "defaultCurrency"
        }
      }).then(function(res) {
        if (res.success) {
          me.value = res.data.data;
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    },
    save() {
      var me = this,
        value = me.value;
      if (!value) {
        me.$weui.topTips("请先选择本位币", 3000);
        return;
      }
      me.$weui.confirm(`确定修改本位币为${value}？`, function() {
        me.$loading({
          url: me.baseUrl + "/update",
          method: "POST",
          jsonData: [
            {
              code: "defaultCurrency",
              data: value
            }
          ]
        })
          .then(function(res) {
            if (res.success) {
              me.$weui.toast("设置成功", 2000);
              me.$router.back();
            } else {
              me.$weui.topTips(res.message, 3000);
            }
          })
          .catch(function() {
            me.$weui.topTips("设置失败", 3000);
          });
      });
    }
  }
};
</script>